// モーダルでエラー表示
export function viewErrorModal(vue, errorObj) {
  console.error(errorObj);

  let errorMessage = "";

  if (errorObj.errors != null) {
    errorMessage = errorObj.errors.reduce(
      (addStr, obj) => addStr + "\n" + obj.message,
      ""
    );
  } else {
    errorMessage = errorObj.message;
  }
  console.log(errorMessage);

  vue.$bvModal.msgBoxOk(errorMessage).catch((err) => {
    console.log(err);
  });
}

// graphql : graphql
// value : クエリの変数
// f : クエリのあとの処理
export function graphqlQuery(vue, graphql, value, f) {
  // console.log(value, f);
  vue.$Amplify.API.graphql({
    query: graphql,
    variables: value,
  })
    .then((a) => {
      f(a);
    })
    .catch((e) => {
      viewErrorModal(vue, e);
    });
}
